var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { version } from './version.js';
import { resizeImage } from './resizer.js';
const DEFAULT_TIMEOUT = 15000;
const USER_AGENT = `visearch-js-sdk/${version}`;
// *********************************************
// Helper methods
// *********************************************
function timeout(ms, promise) {
    const to = new Promise((_, reject) => setTimeout(() => reject(Error(`Timed out in ${ms} ms`)), ms));
    return Promise.race([to, promise]);
}
// *********************************************
// HTTP request methods
// *********************************************
/**
 * Generates HTTP headers.
 */
function getHeaders(settings) {
    const output = {
        Accept: 'application/json',
        'X-Requested-With': settings['user_agent'] || USER_AGENT,
    };
    return output;
}
/**
 * Sends the request as configured in the fetch object.
 */
function sendRequest(timeoutInMS, fetchObj, path, callback, failure) {
    const start = new Date().getTime();
    let reqid;
    return timeout(timeoutInMS || DEFAULT_TIMEOUT, fetchObj)
        .then((response) => {
        const res = response.json();
        reqid = response.headers.get('X-Log-ID');
        return res;
    })
        .then((json) => {
        const stop = new Date().getTime();
        console.log(`ViSearch ${path} finished in ${stop - start}ms`);
        if (reqid && !json.reqid) {
            json.reqid = reqid;
        }
        if (typeof callback === 'function') {
            callback(json);
        }
    })
        .catch((ex) => {
        console.error(`Failed to process api: ${path}.`, ex);
        if (typeof failure === 'function') {
            failure(ex);
        }
    });
}
export const sendGetRequest = (settings, endpoint, path, queryParams, callback, failure) => {
    const url = new URL(endpoint);
    url.pathname = path;
    Object.entries(queryParams).forEach(([param, value]) => {
        if (Array.isArray(value)) {
            value.forEach((i) => {
                if (i != null) {
                    url.searchParams.append(param, String(i));
                }
            });
        }
        else if (value != null) {
            url.searchParams.append(param, String(value));
        }
    });
    const fetchObj = fetch(url, {
        method: 'GET',
        headers: getHeaders(settings),
    });
    return sendRequest(settings.timeout, fetchObj, path, callback, failure);
};
export const sendPostRequest = (settings, endpoint, path, queryParams, callback, failure) => __awaiter(void 0, void 0, void 0, function* () {
    const url = new URL(endpoint);
    url.pathname = path;
    const postData = new FormData();
    if (queryParams['image']) {
        const img = queryParams['image'];
        delete queryParams['image'];
        let resizedImage = null;
        if (settings['disable_resize']) {
            resizedImage = img;
        }
        else {
            if (img instanceof Blob) {
                resizedImage = yield resizeImage(img, settings.resize_settings);
            }
            else if (img instanceof HTMLInputElement && img.files) {
                resizedImage = yield resizeImage(img.files[0], settings.resize_settings);
            }
        }
        if (resizedImage) {
            postData.append('image', resizedImage);
        }
    }
    Object.entries(queryParams).forEach(([param, values]) => {
        if (Array.isArray(values)) {
            values.forEach((i) => {
                if (i != null) {
                    postData.append(param, i);
                }
            });
        }
        else if (values != null) {
            postData.append(param, values);
        }
    });
    const fetchObj = fetch(url, {
        method: 'POST',
        headers: getHeaders(settings),
        body: postData,
    });
    return sendRequest(settings.timeout, fetchObj, path, callback, failure);
});
